// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2OVtE","radioRow":"SimpleQuestionBuilderModal_radioRow__1XbhO"};